//
// Autogenerated by Thrift Compiler (0.6.0-en-exported)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;

  module.exports.AuthenticationErrorCode = {
    'UNKNOWN' : 1,
    'BAD_OPENID_FORMAT' : 2,
    'INTERNAL_ERROR' : 3,
    'DATA_REQUIRED' : 4,
    'OPENID_EXPIRED' : 5
  };

  module.exports.UserNotFoundException = Thrift.Exception.define('UserNotFoundException',  {
    1: { alias: 'errorCode', type: Thrift.Type.I32 },
    2: { alias: 'message', type: Thrift.Type.STRING }
  });

  module.exports.SystemException = Thrift.Exception.define('SystemException',  {
    1: { alias: 'errorCode', type: Thrift.Type.I32 },
    2: { alias: 'message', type: Thrift.Type.STRING }
  });

  module.exports.BadOpenIDException = Thrift.Exception.define('BadOpenIDException',  {
    1: { alias: 'errorCode', type: Thrift.Type.I32 },
    2: { alias: 'message', type: Thrift.Type.STRING }
  });

